import {ChangeDetectorRef, Component, ElementRef, Input} from "@angular/core";
import {FUIAbstractPop, PopParentHorizontalAlignment, PopParentVerticalAlignment} from "../../../pops/abstract-pop";
import {FUIPopsService} from "../../../pops/pops.service";
import {FUIFormContext} from "../../../form-context/form-context";
import {FUIPopFormContext} from "../../../form-context/pop-form-context";
import {FUIEventsService} from "../../../events/events.service";
import {FUIResponsiveService} from "../../../page/responsive.service";

@Component({
    providers: [{provide: FUIFormContext, useClass: FUIPopFormContext}],
    selector: "fui-select-pop",
    styleUrls: ["./select-pop.component.scss"],
    templateUrl: "./select-pop.component.html"
})
export class FUISelectPopComponent extends FUIAbstractPop {
    @Input() parentHorizontalAlignment: PopParentHorizontalAlignment = PopParentHorizontalAlignment.CENTER;
    parentVerticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.DYNAMIC;
    @Input() limitWidthToParent: boolean = true;
    adjustHeightToFirstElement: boolean = false;

    constructor(eventsService: FUIEventsService,
                changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                popsService: FUIPopsService,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, elementRef, eventsService, popsService, responsiveService);
    }
}
